import { inject, Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { MonLog } from 'src/app/model/monlogs/mon-log';
import { MonLogsTableService } from './monlogs-table.service';

@Injectable({
  providedIn: 'root',
})
export class AllLogsTableService extends BaseTableService<MonLog> {
  private _monLogTableService = inject(MonLogsTableService);
  constructor() {
    super();
  }

  // Call the base but also pass this call down to the other mon logs table service
  // The other table service is used for the details container to be able to pull in
  // base mon logs for creating new logs of a certain type when selected via actions dropdown
  // on all or active logs pages
  override setSelected(item: MonLog | null): void {
    super.setSelected(item);
    this._monLogTableService.setSelected(item);
  }
}
